import { compose } from 'react-recompose';
import { reduxForm } from 'redux-form/immutable.js';

import { login } from '~/state/ducks/auth/operations.js';
import { getIsEnvProduction, getIsEnvDevelopment } from '~/state/ducks/app/selectors.js';

import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import LoginForm from '../components/LoginForm.jsx';

import mapping from '~/utils/mapping.json';

const { api, license } = mapping;


export default compose(
    withReduxConnect({
        mapStateToProps: (state) => {
            const isEnvProduction = getIsEnvProduction(state);
            const isEnvDevelopment = getIsEnvDevelopment(state);

            const targetOptions = isEnvDevelopment
                ? api.development
                : api.staging;

            const api_url = isEnvProduction
                ? api.by_name.PRODUCTION
                : api.by_name.STAGING;

            return {
                isEnvProduction,
                initialValues: {
                    product_id: license.by_name.NOBLEHOUR,
                    api_url,
                },
                targetOptions,
                productOptions: license.by_item,
            };
        },
    }),
    reduxForm({
        form: 'login',
        onSubmit: login,
        enableReinitialize: true,
    }),
)(LoginForm);
